import React from 'react';
import PropTypes from 'prop-types';

const Error = ({ code, message }) => (
  <div className="Error">
    <div className="Error_inner">
      <h2 className="Error_title">Oops we have encountered an problem</h2>
      <h4>{code}</h4>
      <p className="Error_message">{message}</p>
    </div>
  </div>
);

Error.propTypes = {
  code: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default Error;
